module.exports = __webpack_public_path__ + "media/images/client/MediaReviews/mediametrics-c804f8c9fc7bffb15081d860cefcbda5.svg";